import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ children, className = '', hover = false, ...props }) => {
  const baseClasses = 'bg-white rounded-lg shadow-sm border border-gray-200';
  const hoverClasses = hover ? 'hover:shadow-md transition-shadow duration-200' : '';

  if (hover) {
    return (
      <motion.div
        whileHover={{ y: -2 }}
        className={`${baseClasses} ${hoverClasses} ${className}`}
        style={{ backgroundColor: '#ffffff', borderColor: '#c8d8e4' }}
        {...props}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <div 
      className={`${baseClasses} ${className}`} 
      style={{ backgroundColor: '#ffffff', borderColor: '#c8d8e4' }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;